import { Component, OnInit, Input } from "@angular/core";
import { ApiService } from "./../../shared/api.service";
import { Router, ActivatedRoute } from "@angular/router";
import { saveAs } from "file-saver";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { NbDialogRef, NbToastrService } from "@nebular/theme";
import { UserService } from "./../../@core/data/users.service";
import { ConfirmationService } from "primeng/api";

@Component({
  selector: "educational",
  templateUrl: 'educationalformPGDiploma.component.html',
  providers: [ConfirmationService],
})
export class EducationalFormPGDComponent implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  @Input() autoName: string;
  @Input() yearValue = [];
  @Input() showSpecialization: string;
  @Input() course_name_auto: string;
  @Input() college_year_auto: string;
  // @Input() courseShortName: string;
  validations_flag = false;
  feedback_message;
  showExperience = false;
  classValidation = true;
  totalMarks: number;
  totalCnG: number;
  totalcgpa: number;
  validPattern = "^[a-zA-Z0-9]+$"; //"[a-zA-Z0-9]+";
  formData: FormGroup;
  edu_form: FormGroup;
  public filterInput = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput2 = new FormControl("", [
    Validators.required,
    Validators.pattern(this.validPattern),
  ]);
  public filterInput3 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput4 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput5 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput6 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput7 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput8 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput9 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput10 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput11 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  public filterInput12 = new FormControl(
    "",
    Validators.pattern(this.validPattern)
  );
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  semesterValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;
  hourValue: any;
  hourValue8: any;
  hourValue7: any;
  hourValue6: any;
  hourValue5: any;
  hourValue4: any;
  hourValue3: any;
  hourValue2: any;
  hourValue9: any;
  hourValue10: any;
  hourValue11: any;
  hourValue12: any;
  lecVal1: any;
  lecVal2: any;
  lecVal3: any;
  lecVal4: any;
  lecVal5: any;
  lecVal6: any;
  lecVal7: any;
  lecVal8: any;
  lecVal9: any;
  lecVal10: any;
  lecVal11: any;
  lecVal12: any;
  getcxg1: number;
  getcxg2: number;
  getcxg3: number;
  getcxg4: number;
  getcxg5: number;
  getcxg6: number;
  getcxg7: number;
  getcxg8: number;
  getcxg9: number;
  getcxg10: number;
  getcxg11: number;
  getcxg12: number;
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  subjectName11: any;
  withoutCodeSub11: any;
  subjectName12: any;
  withoutCodeSub12: any;
  course_code1: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code8: any;
  course_code9: any;
  course_code10: any;
  course_code11: any;
  course_code12: any;
  term2: string;
  term1: string;
  course_data2: any;
  course_data4: any;
  course_data5: any;
  course_data6: any;
  course_data7: any;
  course_data8: any;
  course_data9: any;
  course_data10: any;
  course_data11: any;
  course_data12: any;
  abc5: any;
  // course_code: any;
  prac_hour1: any;
  prac_hour2: any;
  prac_hour3: any;
  prac_hour4: any;
  prac_hour5: any;
  prac_hour6: any;
  prac_hour7: any;
  prac_hour8: any;
  prac_hour9: any;
  prac_hour10: any;
  prac_hour11: any;
  prac_hour12: any;
  lec_per_week1: string;
  lec_per_week2: string;
  lec_per_week3: string;
  lec_per_week4: string;
  lec_per_week5: string;
  lec_per_week6: string;
  lec_per_week7: string;
  lec_per_week8: string;
  lec_per_week9: string;
  lec_per_week10: string;
  lec_per_week11: string;
  lec_per_week12: string;
  public filterText: any;
  public filterText2: any;
  filterText3: any;
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  autocheck = true;
  markFirstOut: any;
  markSecondOut: string;
  markThirdOut: string;
  markFourthOut: string;
  markFifthOut: string;
  markSixthOut: string;
  markSeventhOut: string;
  markEighthOut: string;
  markNinthOut: string;
  markTenthOut: string;
  markElevanthOut: string;
  markTwelfthOut: string;
  showcodeDropdown1: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;
  showcodeDropdown11: boolean = true;
  showcodeDropdown12: boolean = true;
  newcourse_code = [];
  course_name;
  college_year;
  edu_level;
  semester_auto;
  subjectArray1 = [];
  subjectArray2 = [];
  subjectArray3 = [];
  subjectArray4 = [];
  subjectArray5 = [];
  subjectArray6 = [];
  subjectArray7 = [];
  subjectArray8 = [];
  subjectArray9 = [];
  subjectArray10 = [];
  subjectArray11 = [];
  subjectArray12 = [];
  isLoadingResults: boolean = false;
  isDisabled = false;
  constructor(
    protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public toasterService: NbToastrService,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<EducationalFormPGDComponent>
  ) { }

  async ngOnInit() {
    if (this.admin_show == "true") {
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }

    // Initialize formData
    this.formData = this.formBuilder.group({
      courseCode: [''], // Example control for course code
    });

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ["", Validators.required],
      // overallclassCtrl: ["", Validators.required],
      collegeYearCtrl: ["", Validators.required],
      // semesterCtrl: ["", Validators.required],
      monthCtrl: ["", Validators.required],
      yearCtrl: ["", Validators.required],
      // overAllGradeCtrl: ["", Validators.required],
      overAllgpasgpiCtrl: [""],
      markFirstCtrl: [""],
      markFirstOutCtrl: [""],
      gradeFirstCtrl: ["",],
      markFirstAwaredCtrl: [""],
      markSecondAwaredCtrl: [""],
      markThirdAwaredCtrl: [""],
      markFourthAwaredCtrl: [""],
      markFifthAwaredCtrl: [""],
      markSixthAwaredCtrl: [""],
      markSeventhAwaredCtrl: [""],
      markEighthAwaredCtrl: [""],
      markNinethAwaredCtrl: [""],
      markTenthAwaredCtrl: [""],
      markElevanthAwaredCtrl: [""],
      markTwelfthAwaredCtrl: [""],
      subjectFirstCtrl: ["", Validators.required],
      subjectSecondCtrl: [""],
      markSecondCtrl: [""],
      markSecondOutCtrl: [""],
      gradeSecondCtrl: [""],
      subjectThirdCtrl: [""],
      markThirdCtrl: [""],
      markThirdOutCtrl: [""],
      gradeThirdCtrl: [""],
      subjectFourthCtrl: [""],
      markFourthCtrl: [""],
      markFourthOutCtrl: [""],
      gradeFourthCtrl: [""],
      subjectFifthCtrl: [""],
      markFifthCtrl: [""],
      markFifthOutCtrl: [""],
      gradeFifthCtrl: [""],
      subjectSixthCtrl: [""],
      markSixthCtrl: [""],
      markSixthOutCtrl: [""],
      gradeSixthCtrl: [""],
      subjectSeventhCtrl: [""],
      markSeventhCtrl: [""],
      markSeventhOutCtrl: [""],
      gradeSeventhCtrl: [""],
      subjectEighthCtrl: [""],
      markEighthCtrl: [""],
      markEighthOutCtrl: [""],
      gradeEighthCtrl: [""],
      subjectNinthCtrl: [""],
      markNinthCtrl: [""],
      markNinthOutCtrl: [""],
      gradeNinthCtrl: [""],
      subjectTenthCtrl: [""],
      markTenthCtrl: [""],
      markTenthOutCtrl: [""],
      gradeTenthCtrl: [""],
      subjectElevanthCtrl: [""],
      markElevanthCtrl: [""],
      markElevanthOutCtrl: [""],
      gradeElevanthCtrl: [""],
      subjectTwelfthCtrl: [""],
      markTwelfthCtrl: [""],
      markTwelfthOutCtrl: [""],
      gradeTwelfthCtrl: [""],
      instructionCtrl: ["", Validators.required],
      specialInstrctionCtrl: [""],
      finalgradespecialInstrctionCtrl: [""],
      totalweeksCtrl: [""],
      specializationCtrl: [""],
      // overAllCgpaCtrl: [""],
    });

    if (this.college_year_auto == 'firstYear') {
      this.college_year = 'First';
    } else if (this.college_year_auto == 'secondYear') {
      this.college_year = 'Second';
    } else if (this.college_year_auto == 'thirdYear') {
      this.college_year = 'Third';
    }

    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50))
      .fill("")
      .map((v, idx) => now - idx);

    // this.loadAllData();

    this.api.getCouses().subscribe((data: any) => {
      if (data['status'] == 200) {
        this.course_data = data['data'];

        if (this.course_name_auto) {
          const course = this.course_data.find(
            (element) =>
              element.CourseName === this.course_name_auto ||
              element.CourseShortForm === this.course_name_auto
          );
          if (course) {
            this.course_name = course.CourseShortForm;
            this.edu_level = course.type;
          }
        }
      }
      this.isLoadingResults = true;
      this.api.getCouseCodeYearly(this.course_name, this.college_year).subscribe((data: any) => {
        if (data['status'] == 200) {
          this.autocheck = false;
          const filterInputs = [
            { filterText: 'filterText', course_code: 'course_code1', input: this.filterInput },
            { filterText: 'filterText2', course_code: 'course_code2', input: this.filterInput2 },
            { filterText: 'filterText3', course_code: 'course_code3', input: this.filterInput3 },
            { filterText: 'filterText4', course_code: 'course_code4', input: this.filterInput4 },
            { filterText: 'filterText5', course_code: 'course_code5', input: this.filterInput5 },
            { filterText: 'filterText6', course_code: 'course_code6', input: this.filterInput6 },
            { filterText: 'filterText7', course_code: 'course_code7', input: this.filterInput7 },
            { filterText: 'filterText8', course_code: 'course_code8', input: this.filterInput8 },
            { filterText: 'filterText9', course_code: 'course_code9', input: this.filterInput9 },
            { filterText: 'filterText10', course_code: 'course_code10', input: this.filterInput10 },
            { filterText: 'filterText11', course_code: 'course_code11', input: this.filterInput11 },
            { filterText: 'filterText12', course_code: 'course_code12', input: this.filterInput12 },
          ];
          

          
          filterInputs.forEach((filter) => {
            this[filter.filterText] = '';
            this[filter.course_code] = data['data'];

            filter.input.valueChanges.debounceTime(200).subscribe((term) => {
              this[filter.filterText] = term;
            });
          });
          this.isLoadingResults = false;
        }
      });
    });

    if (this.user_id && this.edu_id) {
      
      this.isLoadingResults = true;
      this.api.getEducation(this.edu_id, this.user_id).subscribe((data: any) => {
        if (data["status"] == 200) {
          this.edu_data = data["data"];
          this.course_name = this.edu_data.CourseName;
          this.college_year = this.edu_data.CollegeYear;
          this.semester_auto = this.edu_data.Semester;

          // Initialize the arrays dynamically
          const courseCodes = [
            'course_code_one', 'course_code_two', 'course_code_third',
            'course_code_Fourth', 'course_code_Fifth', 'course_code_Six',
            'course_code_Seventh', 'course_code_Eighth', 'course_code_Ninth',
            'course_code_Tenth', 'course_code_Elevanth', 'course_code_Twelfth'
          ];

          // Make sure each subjectArray is defined before using it
          courseCodes.forEach((_, index) => {
            this[`subjectArray${index + 1}`] = this[`subjectArray${index + 1}`] || [];
            
          });



          // Proceed with API response handling
          courseCodes.forEach((code, index) => {
            const codeData = this.edu_data[code];
            if (codeData) {
              this[`showcodeDropdown${index + 1}`] = false;
              setTimeout(() => {
                if (this[`course_code${index + 1}`]) {  // Ensure data exists
                  this[`course_code${index + 1}`].forEach((element) => {
                    if (element["Course_Code"] === codeData) {
                      
                      this[`subjectArray${index + 1}`].push(element);
                    }
                  });
                }
              }, 3000);
            } else {
              this[`showcodeDropdown${index + 1}`] = true;
            }
          });
          this.isLoadingResults = false;
        }
      });
    }
  }

  getCourse(value) {

    //this.filterText = "";
    this.subjectName = value;
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour1 = value.Lec_per_Week;
        this.lec_per_week1 = "-";
      } else {
        this.lec_per_week1 = value.Lec_per_Week;
        this.prac_hour1 = "-";

      }
    } else {
      this.lec_per_week1 = value.Lec_per_Week;
      this.prac_hour1 = "";
    }

    var count = 0;
    this.newcourse_code = [];
    this.course_code1.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray1.push(element);
      }
      count++;
      if (element["id"] == this.subjectName["id"]) {

      } else {

        this.newcourse_code.push(element);


      }

      if (count == this.course_code1.length) {
        this.course_code1 = this.newcourse_code;
      }
    });
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {

    this.withoutCodeSub = event.target.value;
    for (let a of this.course_code2) {

      if (a.Course_Code == this.withoutCodeSub) {

        this.subjectName = a;
      }
    }
    if (this.subjectName) {

    } else {

    }
  }

  getCourse2(value) {

    //this.filterText = "";
    this.subjectName2 = value;
    this.course_code2.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray2.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour2 = value.Lec_per_Week;
        this.lec_per_week2 = "-";
      } else {
        this.lec_per_week2 = value.Lec_per_Week;
        this.prac_hour2 = "-";

      }
    } else {
      this.lec_per_week2 = value.Lec_per_Week;
      this.prac_hour2 = "";
    }

    var count = 0;
    this.newcourse_code = [];
    this.course_code3.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"]
      ) {

      } else {

        this.newcourse_code.push(element);


      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code;
      }
    });
  }

  getSubject2(event: any) {

    this.withoutCodeSub2 = event.target.value;
    for (let a of this.course_code1) {

      if (a.Course_Code == this.withoutCodeSub2) {

        this.subjectName2 = a;
      }
    }
  }

  getCourse3(value) {
    this.subjectName3 = value;
    this.course_code3.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray3.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour3 = value.Lec_per_Week;
        this.lec_per_week3 = "-";
      } else {
        this.lec_per_week3 = value.Lec_per_Week;
        this.prac_hour3 = "-";

      }
    } else {
      this.lec_per_week3 = value.Lec_per_Week;
      this.prac_hour3 = "-";
    }

    var count = 0;
    this.newcourse_code = [];
    this.course_code4.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"]
      ) {

      } else {

        this.newcourse_code.push(element);


      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code;
      }
    });
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value;
    for (let a of this.course_code3) {

      if (a.Course_Code == this.withoutCodeSub3) {
        this.subjectName3 = a;
      }
    }
  }

  getCourse4(value) {
    this.subjectName4 = value;
    this.course_code4.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray4.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour4 = value.Lec_per_Week;
        this.lec_per_week4 = "-";
      } else {
        this.lec_per_week4 = value.Lec_per_Week;
        this.prac_hour4 = "-";

      }
    } else {
      this.lec_per_week4 = value.Lec_per_Week;
      this.prac_hour4 = "";
    }

    var count = 0;
    this.newcourse_code = [];
    this.course_code5.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"]
      ) {
      } else {
        this.newcourse_code.push(element);


      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code;
      }
    });
  }

  getSubject4(event: any) {

    this.withoutCodeSub4 = event.target.value;
    for (let a of this.course_code4) {

      if (a.Course_Code == this.withoutCodeSub4) {

        this.subjectName4 = a;
      }
    }
  }

  getCourse5(value) {
    this.subjectName5 = value;
    this.course_code5.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray5.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {

      if (value.prac == "yes") {

        this.prac_hour5 = value.Lec_per_Week;
        this.lec_per_week5 = "-";
      } else {
        this.lec_per_week5 = value.Lec_per_Week;
        this.prac_hour5 = "-";

      }
    } else {
      this.lec_per_week5 = value.Lec_per_Week;
      this.prac_hour5 = "";
    }

    var count = 0;
    this.newcourse_code = [];
    this.course_code6.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"]
      ) {
      } else {
        this.newcourse_code.push(element);


      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code;
      }
    });
  }

  getSubject5(event: any) {

    this.withoutCodeSub5 = event.target.value;
    for (let a of this.course_code5) {

      if (a.Course_Code == this.withoutCodeSub5) {

        this.subjectName5 = a;
      }
    }
  }

  getCourse6(value) {
    this.subjectName6 = value;
    this.course_code6.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray6.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour6 = value.Lec_per_Week;
        this.lec_per_week6 = "-";
      } else {
        this.lec_per_week6 = value.Lec_per_Week;
        this.prac_hour6 = "-";

      }
    } else {
      this.lec_per_week6 = value.Lec_per_Week;
      this.prac_hour6 = "";
    }

    var count = 0;
    this.newcourse_code = [];
    this.course_code7.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"]
      ) {
      } else {
        this.newcourse_code.push(element);


      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code;
      }
    });
  }

  getSubject6(event: any) {

    this.withoutCodeSub6 = event.target.value;
    for (let a of this.course_code6) {

      if (a.Course_Code == this.withoutCodeSub6) {

        this.subjectName6 = a;
      }
    }
  }

  getCourse7(value) {
    this.subjectName7 = value;
    this.course_code7.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray7.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour7 = value.Lec_per_Week;
        this.lec_per_week7 = "-";
      } else {
        this.lec_per_week7 = value.Lec_per_Week;
        this.prac_hour7 = "-";

      }
    } else {
      this.lec_per_week7 = value.Lec_per_Week;
      this.prac_hour7 = "";
    }

    var count = 0;
    this.newcourse_code = [];
    this.course_code8.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"] ||
        element["id"] == this.subjectName7["id"]
      ) {
      } else {
        this.newcourse_code.push(element);


      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code;
      }
    });
  }
  getSubject7(event: any) {

    this.withoutCodeSub7 = event.target.value;
    for (let a of this.course_code7) {

      if (a.Course_Code == this.withoutCodeSub7) {

        this.subjectName7 = a;
      }
    }
  }
  getSubject8(event: any) {

    this.withoutCodeSub8 = event.target.value;
    for (let a of this.course_code8) {

      if (a.Course_Code == this.withoutCodeSub8) {

        this.subjectName8 = a;
      }
    }
  }
  getCourse8(value) {
    this.subjectName8 = value;
    this.course_code8.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray8.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour8 = value.Lec_per_Week;
        this.lec_per_week8 = "-";
      } else {
        this.lec_per_week8 = value.Lec_per_Week;
        this.prac_hour8 = "-";

      }
    } else {
      this.lec_per_week8 = value.Lec_per_Week;
      this.prac_hour8 = "";
    }
  }
  getCourse9(value) {
    this.subjectName9 = value;
    this.course_code9.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray9.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour9 = value.Lec_per_Week;
        this.lec_per_week9 = "-";
      } else {
        this.lec_per_week9 = value.Lec_per_Week;
        this.prac_hour9 = "-";

      }
    } else {
      this.lec_per_week9 = value.Lec_per_Week;
      this.prac_hour9 = "";
    }
  }
  getSubject9(event: any) {

    this.withoutCodeSub9 = event.target.value;
    for (let a of this.course_code9) {

      if (a.Course_Code == this.withoutCodeSub9) {

        this.subjectName9 = a;
      }
    }
  }
  getCourse10(value) {
    this.subjectName10 = value;
    this.course_code10.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray10.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour10 = value.Lec_per_Week;
        this.lec_per_week10 = "-";
      } else {
        this.lec_per_week10 = value.Lec_per_Week;
        this.prac_hour10 = "-";

      }
    } else {
      this.lec_per_week10 = value.Lec_per_Week;
      this.prac_hour10 = "";
    }
  }

  getSubject10(event: any) {

    this.withoutCodeSub10 = event.target.value;
    for (let a of this.course_code10) {

      if (a.Course_Code == this.withoutCodeSub10) {

        this.subjectName10 = a;
      }
    }
  }

  getCourse11(value) {
    this.subjectName11 = value;
    this.course_code11.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray11.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour11 = value.Lec_per_Week;
        this.lec_per_week11 = "-";
      } else {
        this.lec_per_week11 = value.Lec_per_Week;
        this.prac_hour11 = "-";

      }
    } else {
      this.lec_per_week11 = value.Lec_per_Week;
      this.prac_hour11 = "";
    }
  }

  getSubject11(event: any) {

    this.withoutCodeSub11 = event.target.value;
    for (let a of this.course_code11) {

      if (a.Course_Code == this.withoutCodeSub11) {

        this.subjectName11 = a;
      }
    }
  }

  getCourse12(value) {
    this.subjectName12 = value;
    this.course_code12.forEach((element) => {
      if (element["Course_Code"] == value["Course_Code"]) {
        this.subjectArray12.push(element);
      }
    });
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == "yes") {

        this.prac_hour12 = value.Lec_per_Week;
        this.lec_per_week12 = "-";
      } else {
        this.lec_per_week12 = value.Lec_per_Week;
        this.prac_hour12 = "-";

      }
    } else {
      this.lec_per_week12 = value.Lec_per_Week;
      this.prac_hour12 = "";
    }
  }

  getSubject12(event: any) {

    this.withoutCodeSub12 = event.target.value;
    for (let a of this.course_code12) {

      if (a.Course_Code == this.withoutCodeSub12) {

        this.subjectName12 = a;
      }
    }
  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    // this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    // this.classValidation = true;

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      // this.edu_form.controls.overAllGradeCtrl.markAsDirty();
      this.edu_form.controls.overAllgpasgpiCtrl.markAsDirty();
      this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.gradeFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstAwaredCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeSecondCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeThirdCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeFourthCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();

      if (
        this.edu_form.controls.instructionCtrl.value === null ||
        this.edu_form.controls.instructionCtrl.value === "" ||
        this.edu_form.controls.instructionCtrl.value === undefined
      ) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (
        this.edu_form.controls.courseNameCtrl.value === null ||
        this.edu_form.controls.courseNameCtrl.value === "" ||
        this.edu_form.controls.courseNameCtrl.value === undefined
      ) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (
        this.edu_form.controls.collegeYearCtrl.value === null ||
        this.edu_form.controls.collegeYearCtrl.value === "" ||
        this.edu_form.controls.collegeYearCtrl.value === undefined
      ) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      // if (
      //   this.edu_form.controls.overallclassCtrl.value === null ||
      //   this.edu_form.controls.overallclassCtrl.value === "" ||
      //   this.edu_form.controls.overallclassCtrl.value === undefined
      // ) {
      //   this.classValidation = false;
      // } else {
      //   this.classValidation = true;
      // }

      // if (
      //   this.edu_form.controls.semesterCtrl.value === null ||
      //   this.edu_form.controls.semesterCtrl.value === "" ||
      //   this.edu_form.controls.semesterCtrl.value === undefined
      // ) {
      //   this.semesterValidation = false;
      // } else {
      //   this.semesterValidation = true;
      // }

      if (
        this.edu_form.controls.monthCtrl.value === null ||
        this.edu_form.controls.monthCtrl.value === "" ||
        this.edu_form.controls.monthCtrl.value === undefined
      ) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (
        this.edu_form.controls.yearCtrl.value === null ||
        this.edu_form.controls.yearCtrl.value === "" ||
        this.edu_form.controls.yearCtrl.value === undefined
      ) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }
    } else {
      if (this.edu_form.controls.markFirstOutCtrl.value) {
        var a = this.edu_form.controls.markFirstOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markFirstOut =
            this.edu_form.controls.markFirstOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markFirstOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markFirstOut = this.edu_form.controls.markFirstOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markSecondOutCtrl.value) {
        var a = this.edu_form.controls.markSecondOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markSecondOut =
            this.edu_form.controls.markSecondOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markSecondOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markSecondOut = this.edu_form.controls.markSecondOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markThirdOutCtrl.value) {
        var a = this.edu_form.controls.markThirdOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markThirdOut =
            this.edu_form.controls.markThirdOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markThirdOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markThirdOut = this.edu_form.controls.markThirdOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markFourthOutCtrl.value) {
        var a = this.edu_form.controls.markFourthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markFourthOut =
            this.edu_form.controls.markFourthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markFourthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markFourthOut = this.edu_form.controls.markFourthOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markFifthOutCtrl.value) {
        var a = this.edu_form.controls.markFifthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markFifthOut =
            this.edu_form.controls.markFifthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markFifthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markFifthOut = this.edu_form.controls.markFifthOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markSixthOutCtrl.value) {
        var a = this.edu_form.controls.markSixthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markSixthOut =
            this.edu_form.controls.markSixthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markSixthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markSixthOut = this.edu_form.controls.markSixthOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markSeventhOutCtrl.value) {
        var a = this.edu_form.controls.markSeventhOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markSeventhOut =
            this.edu_form.controls.markSeventhOutCtrl.value + ".00";
        }

        // if(this.edu_form.controls.markSeventhOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markSeventhOut = this.edu_form.controls.markSeventhOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markEighthOutCtrl.value) {
        var a = this.edu_form.controls.markEighthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markEighthOut =
            this.edu_form.controls.markEighthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markEighthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markEighthOut = this.edu_form.controls.markEighthOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markNinthOutCtrl.value) {
        var a = this.edu_form.controls.markNinthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markNinthOut =
            this.edu_form.controls.markNinthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markNinthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markNinthOut = this.edu_form.controls.markNinthOutCtrl.value+'.00'

        // }
      }

      if (this.edu_form.controls.markTenthOutCtrl.value) {
        var a = this.edu_form.controls.markTenthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markTenthOut =
            this.edu_form.controls.markTenthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markTenthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markTenthOut = this.edu_form.controls.markTenthOutCtrl.value+'.00'

        // }
      }
      if (this.edu_form.controls.markElevanthOutCtrl.value) {
        var a = this.edu_form.controls.markElevanthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markElevanthOut =
            this.edu_form.controls.markElevanthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markElevanthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markElevanthOut = this.edu_form.controls.markElevanthOutCtrl.value+'.00'

        // }
      }


      if (this.edu_form.controls.markTwelfthOutCtrl.value) {
        var a = this.edu_form.controls.markTwelfthOutCtrl.value.split(".");

        if (a[1]) {
        } else {
          this.markTwelfthOut =
            this.edu_form.controls.markTwelfthOutCtrl.value + ".00";
        }
        // if(this.edu_form.controls.markTwelfthOutCtrl.value.indexOf(".") == 1){

        // }else{
        //   this.markTwelfthOut = this.edu_form.controls.markTwelfthOutCtrl.value+'.00'

        // }
      }

      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        // semester: this.edu_form.controls.semesterCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        // overAllGrade: this.edu_form.controls.overAllGradeCtrl.value,
        overall_gpa_sgpi: this.edu_form.controls.overAllgpasgpiCtrl.value,
        subjectFirst: this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First: this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.markFirstOut
          ? this.markFirstOut
          : this.edu_form.controls.markFirstOutCtrl.value,
        markFirst: this.edu_form.controls.gradeFirstCtrl.value.toUpperCase(),
        subjectSecond: this.edu_form.controls.subjectSecondCtrl.value,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.markSecondOut
          ? this.markSecondOut
          : this.edu_form.controls.markSecondOutCtrl.value,
        markSecond: this.edu_form.controls.gradeSecondCtrl.value
          ? this.edu_form.controls.gradeSecondCtrl.value.toUpperCase()
          : "",
        subjectThird: this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third: this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third: this.markThirdOut
          ? this.markThirdOut
          : this.edu_form.controls.markThirdOutCtrl.value,
        markThird: this.edu_form.controls.gradeThirdCtrl.value
          ? this.edu_form.controls.gradeThirdCtrl.value.toUpperCase()
          : "",
        subjectFourth: this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth: this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth: this.markFourthOut
          ? this.markFourthOut
          : this.edu_form.controls.markFourthOutCtrl.value,
        markFourth: this.edu_form.controls.gradeFourthCtrl.value
          ? this.edu_form.controls.gradeFourthCtrl.value.toUpperCase()
          : "",
        subjectFifth: this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth: this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth: this.markFifthOut
          ? this.markFifthOut
          : this.edu_form.controls.markFifthOutCtrl.value,
        markFifth: this.edu_form.controls.gradeFifthCtrl.value
          ? this.edu_form.controls.gradeFifthCtrl.value.toUpperCase()
          : "",
        // overall_class: this.edu_form.controls.overallclassCtrl.value,
        subjectSixth: this.edu_form.controls.subjectSixthCtrl.value,
        marks_obt_Six: this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six: this.markSixthOut
          ? this.markSixthOut
          : this.edu_form.controls.markSixthOutCtrl.value,
        markSixth: this.edu_form.controls.gradeSixthCtrl.value
          ? this.edu_form.controls.gradeSixthCtrl.value.toUpperCase()
          : "",
        subjectSeventh: this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh: this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh: this.markSeventhOut
          ? this.markSeventhOut
          : this.edu_form.controls.markSeventhOutCtrl.value,
        markSeventh: this.edu_form.controls.gradeSeventhCtrl.value
          ? this.edu_form.controls.gradeSeventhCtrl.value.toUpperCase()
          : "",
        subjectEighth: this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth: this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth: this.markEighthOut
          ? this.markEighthOut
          : this.edu_form.controls.markEighthOutCtrl.value,
        markEighth: this.edu_form.controls.gradeEighthCtrl.value
          ? this.edu_form.controls.gradeEighthCtrl.value.toUpperCase()
          : "",
        subjectNinth: this.edu_form.controls.subjectNinthCtrl.value,
        marks_obt_Ninth: this.edu_form.controls.markNinthCtrl.value,
        marks_out_Ninth: this.markNinthOut
          ? this.markNinthOut
          : this.edu_form.controls.markNinthOutCtrl.value,
        markNinth: this.edu_form.controls.gradeNinthCtrl.value
          ? this.edu_form.controls.gradeNinthCtrl.value.toUpperCase()
          : "",
        subjectTenth: this.edu_form.controls.subjectTenthCtrl.value,
        marks_obt_Tenth: this.edu_form.controls.markTenthCtrl.value,
        marks_out_Tenth: this.markTenthOut
          ? this.markTenthOut
          : this.edu_form.controls.markTenthOutCtrl.value,
        markTenth: this.edu_form.controls.gradeTenthCtrl.value
          ? this.edu_form.controls.gradeTenthCtrl.value.toUpperCase()
          : "",
        subjectElevanth: this.edu_form.controls.subjectElevanthCtrl.value,
        marks_obt_Elevanth: this.edu_form.controls.markElevanthCtrl.value,
        marks_out_Elevanth: this.markElevanthOut
          ? this.markElevanthOut
          : this.edu_form.controls.markElevanthOutCtrl.value,
        markElevanth: this.edu_form.controls.gradeElevanthCtrl.value
          ? this.edu_form.controls.gradeElevanthCtrl.value.toUpperCase()
          : "",
        subjectTwelfth: this.edu_form.controls.subjectTwelfthCtrl.value,
        marks_obt_Twelfth: this.edu_form.controls.markTwelfthCtrl.value,
        marks_out_Twelfth: this.markTwelfthOut
          ? this.markTwelfthOut
          : this.edu_form.controls.markTwelfthOutCtrl.value,
        markTwelfth: this.edu_form.controls.gradeTwelfthCtrl.value
          ? this.edu_form.controls.gradeTwelfthCtrl.value.toUpperCase()
          : "",
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
        special_instruction: this.edu_form.controls.specialInstrctionCtrl.value,
        final_grade_special_instruction:
          this.edu_form.controls.finalgradespecialInstrctionCtrl.value,
        course_code_one: this.subjectName
          ? this.subjectName["Course_Code"]
          : this.withoutCodeSub,
        course_code_two: this.subjectName2
          ? this.subjectName2["Course_Code"]
          : this.withoutCodeSub2,
        course_code_third: this.subjectName3
          ? this.subjectName3["Course_Code"]
          : this.withoutCodeSub3,
        course_code_Fourth: this.subjectName4
          ? this.subjectName4["Course_Code"]
          : this.withoutCodeSub4,
        course_code_Fifth: this.subjectName5
          ? this.subjectName5["Course_Code"]
          : this.withoutCodeSub5,
        course_code_Six: this.subjectName6
          ? this.subjectName6["Course_Code"]
          : this.withoutCodeSub6,
        course_code_Seventh: this.subjectName7
          ? this.subjectName7["Course_Code"]
          : this.withoutCodeSub7,
        course_code_Eighth: this.subjectName8
          ? this.subjectName8["Course_Code"]
          : this.withoutCodeSub8,
        course_code_Ninth: this.subjectName9
          ? this.subjectName9["Course_Code"]
          : this.withoutCodeSub9,
        course_code_Tenth: this.subjectName10
          ? this.subjectName10["Course_Code"]
          : this.withoutCodeSub10,
        course_code_Elevanth: this.subjectName11
          ? this.subjectName11["Course_Code"]
          : this.withoutCodeSub11,
        course_code_Twelfth: this.subjectName12
          ? this.subjectName12["Course_Code"]
          : this.withoutCodeSub12,
        marks_awarded_First: this.edu_form.controls.markFirstAwaredCtrl.value,
        marks_awarded_Second: this.edu_form.controls.markSecondAwaredCtrl.value,
        marks_awarded_Third: this.edu_form.controls.markThirdAwaredCtrl.value,
        marks_awarded_Fourth: this.edu_form.controls.markFourthAwaredCtrl.value,
        marks_awarded_Fifth: this.edu_form.controls.markFifthAwaredCtrl.value,
        marks_awarded_Six: this.edu_form.controls.markSixthAwaredCtrl.value,
        marks_awarded_Seventh: this.edu_form.controls.markSeventhAwaredCtrl.value,
        marks_awarded_Eighth: this.edu_form.controls.markEighthAwaredCtrl.value,
        marks_awarded_Nineth: this.edu_form.controls.markNinethAwaredCtrl.value,
        marks_awarded_Tenth: this.edu_form.controls.markTenthAwaredCtrl.value,
        marks_awarded_Elevanth: this.edu_form.controls.markElevanthAwaredCtrl.value,
        marks_awarded_Twelfth: this.edu_form.controls.markTwelfthAwaredCtrl.value,
      };

      this.api.setEducationalValues(edu_data).subscribe((data: any) => {
        this.ref.close(data);
        (err) => console.error(err);
      });
    }
  }

  dismiss() {
    this.ref.close();
  }

  getTotalCredits() {

    this.totalMarks = 0;

    if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != "" &&
      this.edu_form.controls.markSixthCtrl.value != "" &&
      this.edu_form.controls.markSeventhCtrl.value != "" &&
      this.edu_form.controls.markEighthCtrl.value != "" &&
      this.edu_form.controls.markNinthCtrl.value != "" &&
      this.edu_form.controls.markTenthCtrl.value != "" && this.edu_form.controls.markElevanthCtrl.value != "" && this.edu_form.controls.markTwelfthCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value) +
        Number(this.edu_form.controls.markSixthCtrl.value) +
        Number(this.edu_form.controls.markSeventhCtrl.value) +
        Number(this.edu_form.controls.markEighthCtrl.value) +
        Number(this.edu_form.controls.markNinthCtrl.value) +
        Number(this.edu_form.controls.markTenthCtrl.value) + Number(this.edu_form.controls.markElevanthCtrl.value) + Number(this.edu_form.controls.markTwelfthCtrl.value);

    } else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != "" &&
      this.edu_form.controls.markSixthCtrl.value != "" &&
      this.edu_form.controls.markSeventhCtrl.value != "" &&
      this.edu_form.controls.markEighthCtrl.value != "" &&
      this.edu_form.controls.markNinthCtrl.value != "" &&
      this.edu_form.controls.markTenthCtrl.value != "" && this.edu_form.controls.markElevanthCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value) +
        Number(this.edu_form.controls.markSixthCtrl.value) +
        Number(this.edu_form.controls.markSeventhCtrl.value) +
        Number(this.edu_form.controls.markEighthCtrl.value) +
        Number(this.edu_form.controls.markNinthCtrl.value) +
        Number(this.edu_form.controls.markTenthCtrl.value) + Number(this.edu_form.controls.markElevanthCtrl.value);

    } else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != "" &&
      this.edu_form.controls.markSixthCtrl.value != "" &&
      this.edu_form.controls.markSeventhCtrl.value != "" &&
      this.edu_form.controls.markEighthCtrl.value != "" &&
      this.edu_form.controls.markNinthCtrl.value != "" &&
      this.edu_form.controls.markTenthCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value) +
        Number(this.edu_form.controls.markSixthCtrl.value) +
        Number(this.edu_form.controls.markSeventhCtrl.value) +
        Number(this.edu_form.controls.markEighthCtrl.value) +
        Number(this.edu_form.controls.markNinthCtrl.value) +
        Number(this.edu_form.controls.markTenthCtrl.value);

    }
    //--------------
    else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != "" &&
      this.edu_form.controls.markSixthCtrl.value != "" &&
      this.edu_form.controls.markSeventhCtrl.value != "" &&
      this.edu_form.controls.markEighthCtrl.value != "" &&
      this.edu_form.controls.markNinthCtrl.value != ""

    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value) +
        Number(this.edu_form.controls.markSixthCtrl.value) +
        Number(this.edu_form.controls.markSeventhCtrl.value) +
        Number(this.edu_form.controls.markEighthCtrl.value) +
        Number(this.edu_form.controls.markNinthCtrl.value);


    }
    else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != "" &&
      this.edu_form.controls.markSixthCtrl.value != "" &&
      this.edu_form.controls.markSeventhCtrl.value != "" &&
      this.edu_form.controls.markEighthCtrl.value != ""

    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value) +
        Number(this.edu_form.controls.markSixthCtrl.value) +
        Number(this.edu_form.controls.markSeventhCtrl.value) +
        Number(this.edu_form.controls.markEighthCtrl.value);


    }

    // -----------------------

    else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != "" &&
      this.edu_form.controls.markSixthCtrl.value != "" &&
      this.edu_form.controls.markSeventhCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value) +
        Number(this.edu_form.controls.markSixthCtrl.value) +
        Number(this.edu_form.controls.markSeventhCtrl.value);

    } else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != "" &&
      this.edu_form.controls.markSixthCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value) +
        Number(this.edu_form.controls.markSixthCtrl.value);

    } else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != "" &&
      this.edu_form.controls.markFifthCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value) +
        Number(this.edu_form.controls.markFifthCtrl.value);

    } else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != "" &&
      this.edu_form.controls.markFourthCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value) +
        Number(this.edu_form.controls.markFourthCtrl.value);

    } else if (
      this.edu_form.controls.markSecondCtrl.value != "" &&
      this.edu_form.controls.markThirdCtrl.value != ""
    ) {
      this.totalMarks =
        Number(this.edu_form.controls.markFirstCtrl.value) +
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markThirdCtrl.value);

    } else if (this.edu_form.controls.markSecondCtrl.value != "") {
      this.totalMarks =
        Number(this.edu_form.controls.markSecondCtrl.value) +
        Number(this.edu_form.controls.markFirstCtrl.value);

    }
  }

  copyHoursValue() {

    if (this.edu_form.controls.practicalhourFirstCtrl.value) {
      if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value &&
        this.edu_form.controls.subjectSixthCtrl.value &&
        this.edu_form.controls.subjectSeventhCtrl.value &&
        this.edu_form.controls.subjectEighthCtrl.value
      ) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue7 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue8 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value &&
        this.edu_form.controls.subjectSixthCtrl.value &&
        this.edu_form.controls.subjectSeventhCtrl.value
      ) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue7 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value &&
        this.edu_form.controls.subjectSixthCtrl.value
      ) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value
      ) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value
      ) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value
      ) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value
      ) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
      }
    }
  }

  copyLecValue() {
    if (this.edu_form.controls.lecturehourFirstCtrl.value) {
      if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value &&
        this.edu_form.controls.subjectSixthCtrl.value &&
        this.edu_form.controls.subjectSeventhCtrl.value &&
        this.edu_form.controls.subjectEighthCtrl.value
      ) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal8 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value &&
        this.edu_form.controls.subjectSixthCtrl.value &&
        this.edu_form.controls.subjectSeventhCtrl.value
      ) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value &&
        this.edu_form.controls.subjectSixthCtrl.value
      ) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value &&
        this.edu_form.controls.subjectFifthCtrl.value
      ) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value &&
        this.edu_form.controls.subjectFourthCtrl.value
      ) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value &&
        this.edu_form.controls.subjectThirdCtrl.value
      ) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (
        this.edu_form.controls.subjectFirstCtrl.value &&
        this.edu_form.controls.subjectSecondCtrl.value
      ) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
      }
    }
  }

  getcXg() {
    if (
      this.edu_form.controls.markFirstCtrl.value &&
      this.edu_form.controls.markFirstOutCtrl.value
    ) {
      this.getcxg1 =
        Number(this.edu_form.controls.markFirstCtrl.value) *
        Number(this.edu_form.controls.markFirstOutCtrl.value);
    }

    if (
      this.edu_form.controls.markSecondCtrl.value &&
      this.edu_form.controls.markSecondOutCtrl.value
    ) {
      this.getcxg2 =
        Number(this.edu_form.controls.markSecondCtrl.value) *
        Number(this.edu_form.controls.markSecondOutCtrl.value);
    }

    if (
      this.edu_form.controls.markThirdCtrl.value &&
      this.edu_form.controls.markThirdOutCtrl.value
    ) {
      this.getcxg3 =
        Number(this.edu_form.controls.markThirdCtrl.value) *
        Number(this.edu_form.controls.markThirdOutCtrl.value);
    }

    if (
      this.edu_form.controls.markFourthCtrl.value &&
      this.edu_form.controls.markFourthOutCtrl.value
    ) {
      this.getcxg4 =
        Number(this.edu_form.controls.markFourthCtrl.value) *
        Number(this.edu_form.controls.markFourthOutCtrl.value);
    }

    if (
      this.edu_form.controls.markFifthCtrl.value &&
      this.edu_form.controls.markFifthOutCtrl.value
    ) {
      this.getcxg5 =
        Number(this.edu_form.controls.markFifthCtrl.value) *
        Number(this.edu_form.controls.markFifthOutCtrl.value);
    }

    if (
      this.edu_form.controls.markSixthCtrl.value &&
      this.edu_form.controls.markSixthOutCtrl.value
    ) {
      this.getcxg6 =
        Number(this.edu_form.controls.markSixthCtrl.value) *
        Number(this.edu_form.controls.markSixthOutCtrl.value);
    }

    if (
      this.edu_form.controls.markSeventhCtrl.value &&
      this.edu_form.controls.markSeventhOutCtrl.value
    ) {
      this.getcxg7 =
        Number(this.edu_form.controls.markSeventhCtrl.value) *
        Number(this.edu_form.controls.markSeventhOutCtrl.value);
    }

    if (
      this.edu_form.controls.markEighthCtrl.value &&
      this.edu_form.controls.markEighthOutCtrl.value
    ) {
      this.getcxg8 =
        Number(this.edu_form.controls.markEighthCtrl.value) *
        Number(this.edu_form.controls.markEighthOutCtrl.value);
    }

    if (
      this.edu_form.controls.markNinthCtrl.value &&
      this.edu_form.controls.markNinthOutCtrl.value
    ) {
      this.getcxg9 =
        Number(this.edu_form.controls.markNinthCtrl.value) *
        Number(this.edu_form.controls.markNinthOutCtrl.value);
    }

    if (
      this.edu_form.controls.markTenthCtrl.value &&
      this.edu_form.controls.markTenthOutCtrl.value
    ) {
      this.getcxg10 =
        Number(this.edu_form.controls.markTenthCtrl.value) *
        Number(this.edu_form.controls.markTenthOutCtrl.value);
    }

    if (
      this.edu_form.controls.markElevanthCtrl.value &&
      this.edu_form.controls.markElevanthOutCtrl.value
    ) {
      this.getcxg11 =
        Number(this.edu_form.controls.markElevanthCtrl.value) *
        Number(this.edu_form.controls.markElevanthOutCtrl.value);
    }

    if (
      this.edu_form.controls.markTwelfthCtrl.value &&
      this.edu_form.controls.markTwelfthOutCtrl.value
    ) {
      this.getcxg12 =
        Number(this.edu_form.controls.markTwelfthCtrl.value) *
        Number(this.edu_form.controls.markTwelfthOutCtrl.value);
    }

  }

  onDeleteSubject(no){
    this.api.deleteRecords(this.user_id,this.edu_id,no)
    .subscribe(data => {
      if(data["status"]==200){
        this.ngOnInit();
        this.toasterService.success("Deleted successfully");
      }
    },
    (err)=>console.error(err)
    );
  }

  showcoursecodeDropdown() {
    this.showcodeDropdown1= true;
  }

  showcoursecodeDropdown2() {
    this.showcodeDropdown2 = true;
  }

  showcoursecodeDropdown3() {
    this.showcodeDropdown3 = true;
  }

  showcoursecodeDropdown4() {
    this.showcodeDropdown4 = true;
  }

  showcoursecodeDropdown5() {
    this.showcodeDropdown5 = true;
  }

  showcoursecodeDropdown6() {
    this.showcodeDropdown6 = true;
  }

  showcoursecodeDropdown7() {
    this.showcodeDropdown7 = true;
  }

  showcoursecodeDropdown8() {
    this.showcodeDropdown8 = true;
  }

  showcoursecodeDropdown9() {
    this.showcodeDropdown9 = true;
  }

  showcoursecodeDropdown10() {
    this.showcodeDropdown10 = true;
  }

  showcoursecodeDropdown11() {
    this.showcodeDropdown11 = true;
  }
  showcoursecodeDropdown12() {
    this.showcodeDropdown12 = true;
  }


  showContactDetails() {
    this.confirmationService.confirm({
      message:
        "Email - stxaviers@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;" +
        " Whatsapp - +91 99306 00066",
      header: "Please contact the admin on ",
      icon: "pi pi-exclamation-triangle",
      accept: () => { },
      reject: () => { },
    });
  }
}
